<div [formGroup]="formGroup">
  <div>
    <mat-form-field appearance="outline" class="w-1/3 pr-xs">
      <mat-label>Claim Number</mat-label>
      <input matInput formControlName="claimNumber" required />
      @if (formGroup.get('claimNumber')?.hasError('required')) {
      <mat-error data-pgr-id="matErrorInvalidClaimNumber">
        This field is required.
      </mat-error>
      }
    </mat-form-field>
    <mat-form-field appearance="outline" class="w-1/3 pr-xs">
      <mat-label>Assign to</mat-label>
      <input matInput formControlName="diaryAssignTo" required />
      @if (formGroup.get('diaryAssignTo')?.hasError('required')) {
      <mat-error data-pgr-id="matErrorInvalidDiaryAssignTo">
        This field is required.
      </mat-error>
      } @if (formGroup.get('diaryAssignTo')?.hasError('inactiveRep')) {
      <mat-error data-pgr-id="matErrorInactiveRepDiaryAssignTo">
        This rep is inactive.
      </mat-error>
      } @if (formGroup.get('diaryAssignTo')?.hasError('invalidRep')) {
      <mat-error data-pgr-id="matErrorInvalidRepDiaryAssignTo">
        This is not a valid rep.
      </mat-error>
      }
    </mat-form-field>
    <mat-form-field appearance="outline" class="w-1/3">
      <mat-label>Due date</mat-label>
      <input
        matInput
        placeholder="MM/DD/YYYY"
        [matDatepicker]="minDatePicker"
        formControlName="diaryDueDate"
        [min]="minDate"
        #dateInput
        required
      />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="minDatePicker"
      ></mat-datepicker-toggle>
      <mat-datepicker #minDatePicker></mat-datepicker>
      @if (formGroup.get('diaryDueDate')?.hasError('matDatepickerMin')) {
      <mat-error> Please enter a date on or after today. </mat-error>
      } @if ( formGroup.get('diaryDueDate')?.hasError('required') &&
      !formGroup.get('diaryDueDate')?.valid && !!dateInput.value ) {
      <mat-error> Please enter a valid date. </mat-error>
      } @if ( formGroup.get('diaryDueDate')?.hasError('required') &&
      !dateInput.value ) {
      <mat-error data-pgr-id="matErrorInvalidDiaryAssignTo">
        This field is required.
      </mat-error>
      }
    </mat-form-field>
  </div>
  <div>
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Description</mat-label>
      <input
        matInput
        formControlName="diaryDescription"
        maxlength="30"
        required
      />
      <mat-hint
        >{{ formGroup.get("diaryDescription")?.value?.length || 0 }} / 30
        maximum characters</mat-hint
      >
      @if (formGroup.get('diaryDescription')?.hasError('required')) {
      <mat-error data-pgr-id="matErrorInvalidDiaryDescription">
        This field is required.
      </mat-error>
      } @if ( formGroup.get('diaryDescription')?.hasError('maxlength') ||
      formGroup.get('diaryDescription')?.errors?.pattern ) {
      <mat-error data-pgr-id="matErrorInvalidFormatDiaryDescription">
        Description format is invalid.
      </mat-error>
      }
    </mat-form-field>
  </div>
</div>
